import { callApi } from "./api.service";

export const GetFanPublicDetails = async (
  username: any
) => {
  const endpoints = `/api/public/fanpublic/fan-details?username=${username}`;
  return await callApi(endpoints, "GET", false);
};
